const carouselData = [
    {
        legend: "IITians Empowering Youth For a Better Tomorrow",
        img1: "/images/DSC_0110.JPG",
        img2: "/images/DSC_0110-min.JPG",
        alt: 'Aashayein',
    },
    {
        legend: "IITians Empowering Youth For a Better Tomorrow",
        img1: "/images/DSC_0046.JPG",
        img2: "/images/DSC_0046-min.JPG",
        alt: 'Aashayein',
    },
    {
        legend: "IITians Empowering Youth For a Better Tomorrow",
        img1: "/images/header_bg_1.jpg",
        img2: "/images/header_bg_1-min.jpg",
        alt: 'Students at Jagriti Vidya Mandir(JVM)',
    },
    {
        legend: "IITians Empowering Youth For a Better Tomorrow",
        img1: "/images/JVM2.jpg",
        img2: "/images/JVM2-min.jpg",
        alt: 'We with the students',
    },
]

export default carouselData;